<form action="" method="POST" id="sherlockForm" (submit)="submit($event)">
  <input type="hidden" name="Data" id="data" [value]="data?.value" />
  <input type="hidden" name="Seal" id="seal" [value]="seal?.value" />
  <input
    type="hidden"
    name="InterfaceVersion"
    id="interfaceVersion"
    [value]="interfaceVersion?.value"
  />
  <button type="submit" [disabled]="!isLoaded" mat-flat-button color="primary">
    {{renew ? 'renouveller': 'payer'}}
  </button>
</form>
